<template>
    <div class="page-content" id="actionpoints">
        <Titlebar :incrustation="'beepiz-marker'" class="with-tree-dropdown">
            <h1>{{ $t('ap.titles.manager') }}</h1>
            <TreeDropDown
                :treeData="treeDataPlans"
                :treeOptions="optionsDropDown"
                :selected="selectedPlan"
                :icons="iconsPlans"
                @treeNodeClick='handlePlanNode'
                style="margin-left: 1.5rem;"
            />
        </Titlebar>
        <div class="row" style="height: calc(100vh - 78px - 100px)">
            <LoadingMini ref="loading"></LoadingMini>
            <div class="col-4 full-height">
                <UiCard class="full-height" style="overflow: auto;">
                    <tree
                        ref='treeAP'
                        :treeData="treeData"
                        :options="options"
                        :icons="iconsAP"
                        @treeNodeClick='handleNode'
                        @treeNodeRightClick="handleRightClick" @move="handleMoveTreeNode"
                        @endDrag="handleEndTreeDrag"
                    />
                </UiCard>
            </div>
            <div class="col-8 full-height">
                <UiCard class="full-height relative" style="padding: 0 !important; overflow: hidden;">
                    <div class="plans-logo" v-html="logo"></div>
                    <OutdoorMap :class="[{show:mapMode == 1},{drawing:isDrawing}]" ref="map" :data="apData"
                                :center="center"
                                :zoom="zoom" @loaded="onMapLoaded" @markerMoved="handleMarkerMoved" :readOnlyMode="outdoorReadOnlyMode"></OutdoorMap>
                    <IndoorMap :class="{show:mapMode == 2}" :plan="plan" ref="indoorMap" :data="apData"
                                @markerMoved="handleMarkerMoved"></IndoorMap>
                    <div class="helper" :class="{show:isDrawing}">
                        {{ $t('ap.drawingHelper') }}
                    </div>
                </UiCard>
            </div>
        </div>
        <Toolbar>
            <Btn :class="[{'no-hover':showActions.add},'default']" v-can="'beepiz-add-actionpoints'"
                 @click.native.prevent="toggleActions('add')" :disabled="!addIsActive" v-on-clickaway="closeAddActions">
                <div class="button-actions" :class="{show:showActions.add}">
                    <ul>
                        <li :class="{disabled:!rulesForAdd.ap}" @click.stop="showModalAddAP">
                            <i class="fa beepiz-marker fa-fw"></i> {{ $t('ap.btns.addActions.ap') }}
                        </li>
                        <li :class="{disabled:!rulesForAdd.group}" @click.stop="showModalAddGroup">
                            <i class="beepiz-folder fa-fw"></i> {{ $t('ap.btns.addActions.group') }}
                        </li>
                    </ul>
                </div>
                <i class="fa fa-caret-up"></i>
                <span>{{ $t('global.add') }}</span>
            </Btn>
            <Btn :class="[{'no-hover':showActions.options},'default']" v-can="'beepiz-edit-actionpoints || beepiz-delete-actionpoints'"
                 @click.native.prevent="toggleActions('options')">
                <div class="button-actions" :class="{show:showActions.options}" v-on-clickaway="closeOptionsActions">
                    <ul>
                        <li :class="{disabled:!selectedNode}" @click.stop="handleDeleteAction" v-can="'beepiz-delete-actionpoints'">
                            <i class="fa fa-trash fa-fw"></i> {{ $t('ap.btns.delete') }}
                        </li>
                        <li :class="{disabled:!selectedNode}" @click.stop="showModalEditAP" v-can="'beepiz-edit-actionpoints'">
                            <i class="fa fa-pencil fa-fw"></i> {{ $t('global.edit') }}
                        </li>
                    </ul>
                </div>
                <i class="fa fa-caret-up"></i>
                <span>{{ $t('global.options') }}</span>
            </Btn>
            <Btn :class="'primary pull-right'" v-can="'beepiz-browse-plans'">
                <router-link :to="routePlansManager" tag="span"><i
                        class="fa fa-map"></i><span>{{ $t('ap.btns.plansManager') }}</span></router-link>
            </Btn>
        </Toolbar>

        <Modal ref="modalAddAP" class="ActionPointsModal" :width="modalApWidth" :height="'100%'">
            <span slot="header" v-html="$t('ap.titles.add.ap')"></span>
            <div class="full-height scroll" slot="content">
                <Library ref="library" :chrome="false" :planId="selectedPlanId" @selectAP="handleSelectAp" @cancelAP="handleCancelAp"></Library>
            </div>
        </Modal>

        <Modal ref="modalAddAPGroup">
            <span slot="header" v-html="$t('ap.titles.add.group')"></span>
            <div slot="content">
                <ModalAPGroup ref="modalAddAPGroupForm" @addGroup="handleAddGroup"
                              @editGroup="handleEditGroup" @close="handleCloseGroup"></ModalAPGroup>
            </div>
        </Modal>

    </div>
</template>

<script>
    import Titlebar from "@/components/ui/Titlebar";
    import Toolbar from "@/components/ui/Toolbar";
    import Btn from "@/components/ui/Button";
    import UiCard from "@/components/ui/Card";
    import Modal from '@/components/ui/Modal';
    import Library from '@/views/actionpoints/library/Library';
    import Tree from '@/components/ui/tree/Tree';
    import TreeDropDown from '@/components/ui/tree/TreeDropDown';
    import OutdoorMap from '@/components/plans/map/OutdoorMap';
    import IndoorMap from '@/components/plans/map/IndoorMap';
    import LoadingMini from '@/components/ui/LoadingMini';

    import ModalAPGroup from '@/components/plans/modals/ModalAPGroup';

    import axios from 'axios';
    import Utils from '@/services/utils.js';
    import API from '@/services/API.js';
    import Icons from '@/services/iconMapping.js';

    import state from '@/services/PlanTreeState';

    import {mixin as clickaway} from 'vue-clickaway';

    import srcBlack from '@/assets/img/logo-black.svg';

    import Rules from '@/services/apRules'
    import {useDvFlagAccess} from "../../services/featureFlag";

    export default {
        components: {
            Titlebar,
            Toolbar,
            Btn,
            UiCard,
            Modal,
            Library,
            Tree,
            IndoorMap,
            OutdoorMap,
            TreeDropDown,
            ModalAPGroup,
            LoadingMini
        },
        mixins: [clickaway],
        computed: {
            outdoorReadOnlyMode: function(){
                return this.mapMode == 2;
            },
            routePlansManager: function () {
                if (this.selectedPlan != null) {
                    Utils.getByIdInTree(this.treeData,)
                    return '/plans/manager/' + this.selectedPlan.id;
                }
                return '/plans/manager';
            },
            addIsActive: function () {
                if (this.rulesForAdd != null) {
                    return this.rulesForAdd.zone || this.rulesForAdd.group || this.rulesForAdd.ap;
                }
                return false;
            },
            iconsPlans: function () {
                return Icons.plans;
            },
            iconsAP: function () {
                return Icons.actionpoints;
            },
        },
        created: function () {

        },
        data () {
            return {
                logo: srcBlack,
                center: null,
                zoom: null,
                showActions: {
                    add: false,
                    options: false
                },
                addFirstTime: true,
                optionsFirstTime: true,
                selectedNode: null,
                plan: {},
                mapMode: 0, //0: Aucune, 1: Outdoor, 2: Indoor
                apData: {},
                treeData: null,
                options: {
                    sortable: true,
                    keepActivate: true,
                    constrain: false,
                    group: {
                        name: 'test',
                        pull: function (to, from, el) {
                            return true;
                        },
                        put: function (to, from, el) {
                            if (el.getAttribute('data-type') > 5 && to.el.getAttribute('data-type') > 5) {
                                return false;
                            }
                            return true;
                        }
                    },
                },
                optionsDropDown: {
                    sortable: false,
                    keepActivate: false
                },
                treeDataPlans: [],
                rulesForAdd: {
                    'zone': false,
                    'group': false,
                    'ap': false,
                },
                selectedPlan: null,
                selectedPlanId: null,
                isDrawing: false,
                hasDrawn: false,
                modalApWidth: '100%',
                ctmPos: {
                    x: 0,
                    y: 0,
                    originY: 'top'
                },
                showCtm: false,
            }
        },
        destroyed: function () {

        },
        methods: {
            onMapLoaded: function () {
                this.loadPlanTree();
            },
            handlePlanNode: function (node) {
                this.selectedPlan = node;
                this.selectedPlanId = node.id;
                this.$router.replace({name: "APManagerForPlan", params: {planid: this.selectedPlanId}})
            },
            handleNode: function (node) {
                if (this.selectedNode != null && this.selectedNode.id == node.id) {
                    this.selectedNode = null;
                    this.$refs.treeAP.unactivateNode(node);
                    this.rulesForAdd = Rules.getRules('add', 0);
                    if (this.mapMode == 2) {
                        this.$refs.indoorMap.flyTo();
                    }
                    else {
                        this.$refs.map.flyTo([this.selectedPlan.where.point.lng, this.selectedPlan.where.point.lat], this.selectedPlan.zoom);
                    }
                }
                else {
                    this.selectedNode = node;
                    this.rulesForAdd = Rules.getRules('add', node.type);
                    if (this.selectedNode.type < 6) {
                        if (this.mapMode == 2) {
                            this.$refs.indoorMap.flyTo([this.selectedNode.x, this.selectedNode.y], 10, this.selectedNode);
                        }
                        else {
                            this.$refs.map.flyTo([this.selectedNode.x, this.selectedNode.y], this.selectedPlan.zoom + 1, this.selectedNode);
                        }
                    }
                    else {
                        if (this.mapMode == 2) {

                        }
                        else {
                            this.$refs.map.flyTo([this.selectedPlan.where.point.lng, this.selectedPlan.where.point.lat], this.selectedPlan.zoom);
                        }
                    }
                }
            },
            handleRightClick: function (evt, node) {
            },
            showModalAddGroup: function () {
                this.$refs.modalAddAPGroup.show();
            },
            showModalAddAP: function () {
                if(!useDvFlagAccess("beepiz-action-point-can:create")){
                    this.modalApWidth = '850px';
                }
                else{
                    this.modalApWidth = '1150px';
                }
                this.$refs.modalAddAP.show();
                this.$refs.library.loadList();
                this.$refs.library.edit();
            },
            showModalEditAP: function () {
                this.modalApWidth = '300px';
                this.$refs.modalAddAP.show();
                this.$refs.library.edit(this.selectedNode);
            },
            handleAddGroup: function (obj) {
                var vThis = this;
                var objToEdit = {};
                objToEdit.name = obj.name;
                objToEdit.type = 7;
                axios.post(API.route(API.endpoints.plans.addZone, {planId: this.selectedPlan.id}), objToEdit)
                    .then(response => {
                        vThis.$refs.modalAddAPGroupForm.resetForm();
                        vThis.$refs.modalAddAPGroup.hide();
                        vThis.loadPlanActionpoints(vThis.selectedPlan.id);
                    }).catch(error => {
                })
            },
            handleEditGroup: function () {
                var vThis = this;
                var objToEdit = {};
                objToEdit.name = obj.name;
                axios.put(API.route(API.endpoints.plans.addZone, {planId: this.selectedPlan.id}), objToEdit)
                    .then(response => {
                        vThis.$refs.modalAddAPGroupForm.resetForm();
                        vThis.$refs.modalAddAPGroup.hide();
                        vThis.loadPlanActionpoints(vThis.selectedPlan.id);

                    }).catch(error => {
                })
            },
            handleCloseGroup: function () {
                this.$refs.modalAddAPGroupForm.resetForm();
                this.$refs.modalAddAPGroup.hide();
            },
            handleMarkerMoved: function (node, position) {
                var obj = {};
                obj.x = position.lng;
                obj.y = position.lat;
                axios.put(API.route(API.endpoints.plans.apPlacement, {
                    planId: this.selectedPlan.id,
                    apId: node.id
                }), obj)
                    .then(response => {
                        this.loadPlanActionpointsGeoJson(this.selectedPlanId);
                        this.loadPlanActionpoints(this.selectedPlanId);
                    })
            },
            handleCancelAp: function () {
                this.$refs.modalAddAP.hide();
            },
            handleSelectAp: function (tabSelected) {
                this.$refs.modalAddAP.hide();
                var vThis = this;
                tabSelected.forEach(function (obj, idx) {
                    var objToEdit = {};
                    if (vThis.mapMode == 2) {
                        objToEdit.x = 0;
                        objToEdit.y = 0;
                    }
                    else {
                        if(vThis.selectedPlan.where) {
                            objToEdit.x = vThis.selectedPlan.where.point.lng;
                            objToEdit.y = vThis.selectedPlan.where.point.lat;
                        }
                        else{
                            var coords = Utils.getCentroid(JSON.parse(vThis.selectedPlan.polygon)[0])
                            objToEdit.x = coords[0];
                            objToEdit.y = coords[1];

                        }
                    }
                    if(vThis.selectedNode != null){
                        objToEdit.parentId = vThis.selectedNode.id;
                    }
                    axios.post(API.route(API.endpoints.plans.apAddToPlan, {
                        planId: vThis.selectedPlan.id,
                        apId: obj.id
                    }), objToEdit)
                        .then(response => {
                            vThis.$refs.loading.show();
                            vThis.loadPlanActionpointsGeoJson(vThis.selectedPlan.id);
                            vThis.loadPlanActionpoints(vThis.selectedPlan.id);
                        }).catch(error => {
                    })
                });
            },
            loadPlanTree: function () {
                axios.get(API.endpoints.plans.index)
                    .then(response => {
                        if (this.$route.params.planid != null) {
                            this.selectedPlanId = parseInt(this.$route.params.planid);
                            this.selectedPlan = Utils.getByIdInTree(response.data.children, this.$route.params.planid);
                            var path = this.selectedPlan.pathOrder.split('.');
                            var node = null;
                            for (var i = 1; i < path.length; i++) {
                                node = Utils.getByIdInTree(response.data.children, path[i]);
                                state.opened[node.id] = true;
                                state.active = null;
                            }
                            //this.loadPlanEntity(this.selectedPlanId);
                        }
                        this.treeDataPlans = response.data.children;
                    })
            },
            loadPlanEntity: function (nodeId) {
                axios.get(API.route(API.endpoints.plans.show, {planId: nodeId}))
                    .then(response => {
                        this.$refs.loading.show();
                        this.handlePlanEntity(response.data);
                        this.loadPlanActionpointsGeoJson(nodeId);
                        this.loadPlanActionpoints(nodeId);
                        this.selectedPlan = response.data;
                    })
            },
            loadPlanActionpointsGeoJson: function (nodeId) {
                axios.get(API.route(API.endpoints.plansActionpoints.index+"?withimage=1", {planId: nodeId}), {headers: {Accept: 'application/vnd.geo+json'}})
                    .then(response => {
                        var temp = response.data;
                        temp.features = Utils.addIndexGeojson(temp.features);
                        if(this.selectedPlan.polygon){
                            var polygon = [{
                                "id": this.selectedPlan.id,
                                "type": "Feature",
                                "properties": this.selectedPlan,
                                "geometry": {
                                    "coordinates": JSON.parse(this.selectedPlan.polygon),
                                    "type": "Polygon"
                                }
                            }];
                            temp.features = polygon.concat(temp.features);
                        }
                        this.apData = temp;
                        this.$refs.loading.hide();
                    })
            },
            loadPlanActionpoints: function (nodeId) {
                axios.get(API.route(API.endpoints.plansActionpoints.index+"?withimage=1", {planId: nodeId}))
                    .then(response => {
                        this.treeData = response.data;
                        this.rulesForAdd = Rules.getRules('add', 0);
                        setTimeout(function () {
                            window.Vfc.$refs.loading.hide();
                        }, 500);
                        this.$refs.loading.hide();
                    })
            },
            handlePlanEntity: function (entity) {


                switch (entity.type) {
                    case 2:
                    case 3:
                    case 4:
                        this.handleOutdoor(entity);
                        break;
                    case 7:
                        this.handleOutdoor(entity);
                        this.handlePlan(entity);
                        break;
                }
            },
            handlePlan: function (plan) {
                this.plan = plan.plan;
                this.mapMode = 2;
                this.$refs.indoorMap.setDD();
            },
            handleOutdoor: function (plan) {
                this.$refs.map.map.removeHTMLMarkers();
                if(plan.type == 7){
                    var building = Utils.getBuildingParent(this.treeDataPlans,plan);
                    this.center = [building.where.point.lng, building.where.point.lat];
                    this.$refs.map.map.addHTMLMarker({type:'html',value:'<i class="beepiz-marker"></i><i class="plan-entity-icon '+this.iconsPlans[building.type]+'"></i>'},building.where.point.lat,building.where.point.lng,'marker-plan-entity reverse-color')
                    this.zoom = building.zoom - 1;
                }
                else{
                    this.plan = null;
                    this.mapMode = 1;
                    if(plan.polygon != null){
                        this.$refs.map.showGroup(plan);
                    }
                    else{
                        this.center = [plan.where.point.lng, plan.where.point.lat];
                        this.$refs.map.map.addHTMLMarker({type:'html',value:'<i class="beepiz-marker"></i><i class="plan-entity-icon '+this.iconsPlans[plan.type]+'"></i>'},plan.where.point.lat,plan.where.point.lng,'marker-plan-entity reverse-color')
                        this.zoom = plan.zoom;
                    }
                    this.$refs.map.setDD();
                }
            },
            toggleActions: function (key, force) {
                if (force != null) {
                    this.showActions[key] = force;
                }
                else {
                    this.showActions[key] = !this.showActions[key];
                }
                for (var keyShows in this.showActions) {
                    if (keyShows != key) {
                        this.showActions[keyShows] = false;
                        this[key+'FirstTime'] = true;
                    }
                }
            },
            closeAddActions: function () {
                if (this.showActions['add'] && !this.addFirstTime) {
                    this.showActions['add'] = false;
                    this.addFirstTime = true;
                } else {
                    this.addFirstTime = false;
                }
            },
            closeOptionsActions: function () {
                if (this.showActions['options'] && !this.optionsFirstTime) {
                    this.showActions['options'] = false;
                    this.optionsFirstTime = true;
                } else {
                    this.optionsFirstTime = false;
                }
            },
            handleMoveTreeNode: function (evt) {
                if (parseInt(evt.to.getAttribute('data-type')) >= 6) {
                    document.querySelector('.sortable-ghost .tree-node-inner').classList.remove('level-0');
                    document.querySelector('.sortable-ghost .tree-node-inner').classList.add('level-1');
                }
                if (evt.to.getAttribute('data-type') == null) {
                    document.querySelector('.sortable-ghost .tree-node-inner').classList.add('level-0');
                    document.querySelector('.sortable-ghost .tree-node-inner').classList.remove('level-1');
                }
            },
            handleEndTreeDrag: function (evt) {
                var itemId = evt.item.getAttribute('data-id');
                var dataReorder = this.getParentAndBefore(itemId);
                axios.put(API.route(API.endpoints.plans.orderAP, {planId: this.selectedPlanId, apId: itemId}), dataReorder)
                    .then(response => {
                    }).catch(error => {
                })
            },
            getParentAndBefore: function (id) {
                var obj = {};
                obj.after = 0;
                obj.parentId = null;
                for (var i = 0; i < this.treeData.length; i++) {
                    var item = this.treeData[i];
                    if (item.id == id) {
                        if (this.treeData[i - 1] != null) {
                            obj.after = this.treeData[i - 1].id;
                        }
                    } else if (item.children != null && item.children.length > 0) {
                        for (var j = 0; j < item.children.length; j++) {
                            var itemC = item.children[j];
                            if (itemC.id == id) {
                                obj.parentId = item.id;
                                if (item.children[j - 1] != null) {
                                    obj.after = item.children[j - 1].id;
                                }
                            }
                        }
                    }
                }
                return obj;
            },
            handleDeleteAction: function () {
                var vThis = this;
                window.Vfc.$refs.confirm.show({
                    title: Utils.t('ap.actions.delete.modalTitle'),
                    content: Utils.t('ap.actions.delete.modalContent'),
                    callbackYes: function () {
                        axios.delete(API.route(API.endpoints.plans.apDelete, {planId:vThis.selectedPlanId,apId:vThis.selectedNode.id}))
                            .then(response => {
                                vThis.selectedNode = null;
                                vThis.$refs.loading.show();
                                vThis.loadPlanActionpointsGeoJson(vThis.selectedPlanId);
                                vThis.loadPlanActionpoints(vThis.selectedPlanId);
                            }).catch(error => {
                        })
                    }
                });
            },
        },
        mounted: function () {
        },
        name: '',
        props: [],
        updated: function () {

        },
        watch: {
            selectedPlanId: function (newValue) {
                this.loadPlanEntity(parseInt(newValue));
            },
            treeData: function () {
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
